module.exports = __webpack_public_path__ + "static/media/file-code-regular.8fbc3ab9.svg";